import { ticketClient } from "@/api/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
import { 
  ListVerifyQuestionReq, 
  GetPVRecordReq, 
  SavePVRecordReq,
  SavePVCallReq,
  ListPVCallReq,
  SaveQIRecordReq
 } from "@/pbjs/xcommon/ticket_pb";


// lee 绩效接口参数
interface Options {
  pageIndex: number;
  pageSize: number;
  ticketItemId?: string;
  ticketId?: string;
  orderId?: string;
  customerId?: string;
  addAnswers?: any;
  status?: string;
  remark?: string;
  result?: string;
  phoneConnected?: string;
  phoneObject?: string;
  phoneCallInput?: string;
  phoneTime?: string;
  callId?: string;
  qlRemark?:string;
  qIstatus?:any;
  appname?:any
}
// 问题库
export function listVerifyQuestion(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new ListVerifyQuestionReq();
      request.setCommonin(setCommon());
      request.setOrderid(arg.orderId);
      request.setTicketitemid(arg.ticketItemId);
      request.setAccountid(arg.customerId);
      request.setTicketid(arg.ticketId);
      request.setAppname(arg.appname);
      // setRank
      let _res = await ticketClient.listVerifyQuestion(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 审核提交结果查询
export function getPVRecord(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetPVRecordReq();
      request.setCommonin(setCommon());
      request.setOrderid(arg.orderId);
      request.setTicketid(arg.ticketId);
      request.setTicketitemid(arg.ticketItemId);
      // setRank
      let _res = await ticketClient.getPVRecord(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 审核提交
export function savePVRecord(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SavePVRecordReq();
      request.setCommonin(setCommon());
      request.setOrderid(arg.orderId);
      request.setTicketitemid(arg.ticketItemId);
      request.setPvstatus(arg.status);
      request.setRemark(arg.remark);
      request.setTicketid(arg.ticketId);
      request.setAppname(arg.appname);
      let answersRequestList: any[] = [];
      arg.addAnswers.forEach((item:any)=>{
        let deseriaRequest = new SavePVRecordReq.Answer();
        deseriaRequest.setQuestionid(item.questionid.toString());
        deseriaRequest.setOption(item.option?.toString());
        answersRequestList.push(deseriaRequest);
      })


      request.setAnswersList(answersRequestList);
      // setRank
      let _res = await ticketClient.savePVRecord(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 保存PV通话记录
export function saveCall(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SavePVCallReq();
      request.setCommonin(setCommon());
      let requestInfo: any = new SavePVCallReq.SavePVCallBaseInfo();
      // requestInfo.setResult(arg.result);
      // requestInfo.setRemark(arg.remark);
      requestInfo.setTicketid(arg.ticketId);
      requestInfo.setOrderid(arg.orderId);
      requestInfo.setPhoneconnected(arg.phoneConnected);
      requestInfo.setPhoneobject(arg.phoneObject);
      requestInfo.setPhonecallinput(arg.phoneCallInput);
      requestInfo.setPhonetime(arg.phoneTime);
      requestInfo.setCallid(arg.callId);
      requestInfo.setItemid(arg.ticketItemId);
      request.setBaseinfo(requestInfo);
      // setRank
      let _res = await ticketClient.savePVCallDetail(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 查询PV通话记录
export function ListCall(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new ListPVCallReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setOrderid(arg.orderId);
      request.setTicketitemid(arg.ticketItemId);
      request.setTicketid(arg.ticketId);
      // setRank
      let _res = await ticketClient.listPVCallDetail(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// 质检提交
export function saveQIRecord(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SaveQIRecordReq();
      request.setCommonin(setCommon());
      request.setOrderid(arg.orderId);
      request.setTicketitemid(arg.ticketItemId);
      request.setTicketid(arg.ticketId);
      request.setQistatus(arg.qIstatus);
      request.setRemark(arg.qlRemark);
      request.setAppname(arg.appname);
      // setRank
      let _res = await ticketClient.saveQIRecord(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}